import { InternalApiScenario } from '../api-internal';
import dayjs from 'dayjs';
import React from 'react';
import { SalvModal, SalvProgressStepper, Step } from '@salvapp/ui-components';
import { useQuery } from '@tanstack/react-query';
import { scenarioInternalApi } from '../apis';
import { FULL_DATE_TIME_FORMAT } from '../common/helper';
import { useMe } from '../organisation/useMe';

interface ScenarioHistoryModalProps {
  showModal: boolean;
  onClose: () => void;
  scenario: InternalApiScenario;
}

const ScenarioHistoryModal = ({ scenario, showModal, onClose }: ScenarioHistoryModalProps) => {
  const { currentOrganisation } = useMe();

  const { data: scenarioHistory } = useQuery({
    queryKey: ['scenario_history', scenario, currentOrganisation?.id],
    queryFn: async () => await scenarioInternalApi.getScenarioHistory({ scenarioHandle: scenario.id! }),
    initialData: [],
  });

  return (
    <SalvModal show={showModal} onHide={onClose}>
      <SalvModal.Header closeButton>Scenario history</SalvModal.Header>

      <SalvModal.Body>
        <SalvProgressStepper activeStep={1}>
          {scenarioHistory.map((c, index) => (
            <Step key={index} header={c.action} description={dayjs(c.time).format(FULL_DATE_TIME_FORMAT)} />
          ))}
        </SalvProgressStepper>
      </SalvModal.Body>
    </SalvModal>
  );
};

export default ScenarioHistoryModal;
